import { render, staticRenderFns } from "./CoverDescriptions.vue?vue&type=template&id=44934b5a&scoped=true&"
import script from "./CoverDescriptions.vue?vue&type=script&lang=ts&"
export * from "./CoverDescriptions.vue?vue&type=script&lang=ts&"
import style0 from "./CoverDescriptions.vue?vue&type=style&index=0&id=44934b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44934b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('44934b5a', component.options)
    } else {
      api.reload('44934b5a', component.options)
    }
    module.hot.accept("./CoverDescriptions.vue?vue&type=template&id=44934b5a&scoped=true&", function () {
      api.rerender('44934b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/CoverDescriptions.vue"
export default component.exports